import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    overflow-y: scroll;
`;

export const TextWrapper = styled.div`
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    font-size: small;
`;

export const HeaderWarning = styled.p`
    color: red;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 0;
`;

export const HeaderWarningDetails = styled.p`
    color: red;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 1rem;
    white-space: pre-line;
`;
